export const SET_STATE = 'checkoutPage/paymentModal/SET_STATE';
export const SET_OPEN = 'checkoutPage/paymentModal/SET_OPEN';
export const SET_HIDE_SPINNER = 'checkoutPage/paymentModal/SET_HIDE_SPINNER';
export const SET_CHALLENGE_CONTAINER_REF = 'checkoutPage/paymentModal/SET_CHALLENGE_CONTAINER_REF';
export const RESET_STATE = 'checkoutPage/paymentModal/RESET_STATE';
